import { forwardRef } from "react";
import { Box } from "../box/Box";

interface ISpacerProps {
	size?: string;
	grow?: boolean;
	minHeight?: string;
	element?: "div" | "span";
	variant?: "tiny" | "normal" | "small" | "huge";
}
const Spacer = forwardRef(({ size, grow, minHeight, variant, element }: ISpacerProps, ref) => {
	// determine size
	let trueSize: null | undefined | number = undefined;
	if (!size && !grow && !variant) variant = "normal";
	if (size && typeof size === "string") {
		const sz = parseInt(size);
		if (sz === 10) variant = "small";
		else if (sz === 40) variant = "huge";
		else if (sz === 20) variant = "normal";
		else if (sz === 4) variant = "tiny";
	}

	if (variant) {
		switch (variant) {
			case "tiny":
				trueSize = 5;
				break;
			case "small":
				trueSize = 10;
				break;
			case "huge":
				trueSize = 40;
				break;
			case "normal":
				trueSize = 20;
				break;
		}
	}

	let styleSize = trueSize === undefined && !grow && size ? size : undefined;

	if (!variant && minHeight && !styleSize) {
		styleSize = minHeight;
	}

	let sizeObject = {};

	if (trueSize !== undefined && !grow) {
		sizeObject = {
			minWidth: trueSize + "px",
			minHeight: minHeight ? minHeight : trueSize + "px",
			maxWidth: trueSize + "px",
			maxHeight: trueSize + "px",
			width: trueSize + "px",
			height: !minHeight ? trueSize + "px" : minHeight,
		};
	}

	return (
		<Box
			element={element}
			style={
				styleSize
					? {
							width: styleSize,
							height: styleSize,
							minWidth: styleSize,
							minHeight: styleSize,
							maxWidth: !grow ? styleSize : undefined,
							maxHeight: !grow ? styleSize : undefined,
						}
					: undefined
			}
			ref={ref}
			sx={{
				flexShrink: minHeight ? "0" : "unset",
				flexGrow: grow ? "1" : undefined,
				...sizeObject,
			}}
		/>
	);
});

export default Spacer;
